// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.el-form-item.is-error .file-upload[data-v-496e6a2b]:deep(.el-upload-dragger) {\n\tborder-color: var(--el-color-danger);\n}\n.file-upload[data-v-496e6a2b] {\n\twidth: 100%;\n}\n.file-upload[data-v-496e6a2b]:deep(.el-upload-list__item) {\n\t-webkit-transition: none !important;\n\ttransition: none !important;\n}\n", ""]);
// Exports
module.exports = exports;
